const WEBSOCKET_CHANNELS = [
  'ResourcesChannel',
  'WebsitePagesChannel'
]

const subscribeChannels = (actionCable) => {
  if (!actionCable) return

  WEBSOCKET_CHANNELS.forEach(channel => actionCable.subscribe({ channel }))
}

const unsubscribeChannels = (actionCable) => {
  if (!actionCable) return

  WEBSOCKET_CHANNELS.forEach(channel => actionCable.subscribe(channel))
}

export { subscribeChannels, unsubscribeChannels }